import { ModeForm } from "constants/enum";
import { UPDATE_SUCCESS_MESSAGE } from "constants/index";

import { useEffect, useState } from "react";

import { confirm } from "contexts";
import {
  useCreateOneBaseRequestCandidateControllerRequestCandidateEntity,
  useGetManyBaseRequestHistoryControllerRequestHistoryEntity,
  useGetOneBaseRequestControllerRequestEntity,
  useRequestControllerCheckContractor,
  useRequestControllerSendRequest,
  useUpdateOneBaseRequestControllerRequestEntity,
} from "generated";
import { useNotification } from "hooks/useNotification";
import { useNavigate, useParams } from "react-router-dom";

import { RequestForm } from "./RequestForm";

export const RequestUpdateComponent = () => {
  const [isTriggerSubmit, setIsTriggerSubmit] = useState<boolean>(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: history, refetch: refetchHistory } =
    useGetManyBaseRequestHistoryControllerRequestHistoryEntity({
      s: JSON.stringify({
        requestId: {
          $eq: id,
        },
      }),
      limit: 1,
      join: ["createdBy"],
    });

  const { data, refetch } = useGetOneBaseRequestControllerRequestEntity(
    id as string,
    {
      join: [
        `client`,
        `pic`,
        `assignee`,
        `requestAssignees`,
        `requestAssignees.user`,
      ],
    }
  );
  const {
    mutate,
    error: updateError,
    isSuccess,
  } = useUpdateOneBaseRequestControllerRequestEntity();
  const { mutate: checkContractor } = useRequestControllerCheckContractor();

  useEffect(() => {
    if (isSuccess) {
      navigate("/request");
    }
  }, [isSuccess, navigate]);

  const {
    mutate: addRequestCandidate,
    error: addRequestCandidateError,
    isSuccess: isSuccessRequestCandidate,
  } = useCreateOneBaseRequestCandidateControllerRequestCandidateEntity({
    mutation: {
      onSuccess() {
        setIsTriggerSubmit(!isTriggerSubmit);
      },
    },
  });

  const {
    mutate: sendRequest,
    error: errorRequest,
    isSuccess: isSuccessSendRequest,
    // eslint-disable-next-line
  } = useRequestControllerSendRequest({
    mutation: {
      onSuccess() {
        refetch();
        refetchHistory();
      },
    },
  });

  const handleSendRequest = () => {
    sendRequest({ id: id as string });
  };

  const handleSubmit = (dataSubmit: any) => {
    mutate({
      data: {
        request: {
          name: dataSubmit?.request?.name,
          status: dataSubmit?.request?.status,
          clientId: dataSubmit?.request?.clientId?.value,
          contractor: dataSubmit?.request?.contractor,
          dueDate: dataSubmit?.request?.dueDate,
          requestor: dataSubmit?.request?.requestor,
          picId: dataSubmit?.request?.picId?.value,
          description: dataSubmit?.request?.description,
        },
        ...(dataSubmit?.assigneeIds && dataSubmit?.assigneeIds?.length > 0
          ? {
              assigneeIds: (dataSubmit?.assigneeIds as string[])?.map(
                (e: any) => e?.value as string
              ),
            }
          : {}),
      },
      id: id as string,
    });
  };

  const checkContractorBeforeSubmitting = (dataSubmit: any) => {
    if (dataSubmit?.request?.contractor) {
      checkContractor(
        {
          params: { contractor: dataSubmit.request.contractor },
        },
        {
          onSuccess(val) {
            const isValidEmail = val.data;
            if (isValidEmail) {
              handleSubmit(dataSubmit);
            } else {
              confirm({
                title: "Email not found",
                content:
                  "The email you just entered does not match any internal user information. If the data is entered incorrectly, the system cannot identify it, causing the PIC field to be blank. Do you want to continue?",
                okLabel: "Yes",
                cancelLabel: "No",
              })
                .then(() => handleSubmit(dataSubmit))
                .catch(() => {});
            }
          },
        }
      );
    } else {
      handleSubmit(dataSubmit);
    }
  };

  const handleSubmitRequestCandidate = (dataRequestCandidate: any) => {
    addRequestCandidate({
      data: {
        candidateName: dataRequestCandidate?.candidateName,
        code: dataRequestCandidate?.code,
        level: dataRequestCandidate?.level,
        fileUrl: JSON.stringify(dataRequestCandidate?.fileUrl),
        consentForm: JSON.stringify(dataRequestCandidate?.consentForm),
        degree: JSON.stringify(dataRequestCandidate?.degree),
        description: dataRequestCandidate?.description,
        requestId: dataRequestCandidate?.requestId,
        status: dataRequestCandidate?.status,
      },
    });
  };

  useNotification(
    addRequestCandidateError,
    isSuccessRequestCandidate,
    UPDATE_SUCCESS_MESSAGE
  );
  useNotification(updateError, isSuccess, UPDATE_SUCCESS_MESSAGE);

  useNotification(errorRequest, isSuccessSendRequest, UPDATE_SUCCESS_MESSAGE);

  return data?.data ? (
    <RequestForm
      title="General information"
      handleSubmitForm={checkContractorBeforeSubmitting}
      data={data?.data as any}
      mode={ModeForm.Edit}
      isRefetch={isTriggerSubmit}
      handleSendRequest={handleSendRequest}
      history={history?.data.data[0]}
    />
  ) : null;
};
